<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyName="filterProps.name"
      :keyCode="filterProps.code"
      :keyDateFrom="filterProps.dateFrom"
      :keyDateTo="filterProps.dateTo"
      :keyStatus="filterProps.status"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyName="filterProps.name"
        :keyCode="filterProps.code"
        :keyDateFrom="filterProps.dateFrom"
        :keyDateTo="filterProps.dateTo"
        :keyStatus="filterProps.status"
        @createProfit="createProfit"
        @clearKey="clearKey"
      />
      <ul class="tabs">
        <li class="shadow">
          <a class="active" href="javascript:;">{{
            $t("financial.利润报表管理")
          }}</a>
        </li>
        <li>
          <router-link to="/cost-flow/">{{
            $t("financial.其他支出流水管理")
          }}</router-link>
        </li>
      </ul>
      <router-view
        v-if="isSysRights('Profit.findBySupplier')"
        :first_loading="firstLoading"
        :items="items"
        :typeArr="modalCreateProfit.typeArr"
        @showOperateLog="showOperateLog"
        @modiName="modiName"
        @cancelProfit="cancelProfit"
        @reCalculate="reCalculate"
        @setSkus="setSkus"
        @getOrder="getOrder"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/profit/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
      <Modal
        :modalId="'modalCreateProfit'"
        :home="false"
        :loading="modalCreateProfit.loading"
        :size="'md'"
        :autoH="false"
        :max="modalCreateProfit.max"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("financial.生成利润报表") }}
            </h6>
            <div>
              <button type="button" class="size" @click="changeSize">
                <i
                  class="fa"
                  :class="
                    modalCreateProfit.max
                      ? 'fa-window-restore'
                      : 'fa-window-maximize'
                  "
                ></i>
              </button>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                class="close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div
              v-show="modalCreateProfit.mode == 1"
              class="alert alert-warning mg-b-15 pd-y-5 tx-center"
            >
              {{ $t("financial.请先选择起始日期,截止日期") }}
            </div>
            <div class="form-group row">
              <label class="col-3 col-form-label form-control-sm text-right">
                {{ $t("financial.统计时段：") }}<span class="tx-danger">*</span>
              </label>
              <div class="col-8 datepicker-group d-flex">
                <div class="input-group mg-r-5 col-5 pd-l-0">
                  <input
                    data-id="datepicker-from"
                    type="text"
                    class="form-control fc-datepicker form-control-sm"
                    :placeholder="$t('financial.起始日期')"
                    readonly="true"
                    v-model="modalCreateProfit.dateFrom"
                  />
                </div>
                <div class="input-group col-5 pd-l-0">
                  <input
                    data-id="datepicker-to"
                    type="text"
                    class="form-control fc-datepicker form-control-sm"
                    :placeholder="$t('financial.截止日期')"
                    readonly="true"
                    v-model="modalCreateProfit.dateTo"
                  />
                </div>
              </div>
            </div>
            <div v-show="modalCreateProfit.mode == 2">
              <div class="form-group row align-items-center">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.时段内订单数：") }}</label
                >
                <div class="col-8">
                  <span>{{ modalCreateProfit.orderCnt }}</span>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.时段内生产单数：") }}</label
                >
                <div class="col-8">
                  <span>{{ modalCreateProfit.productCnt }}</span>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.时段内采购单数：") }}</label
                >
                <div class="col-8">
                  <span>{{ modalCreateProfit.purchaseCnt }}</span>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.利润统计方法：") }}</label
                >
                <div class="col-5">
                  <select
                    class="form-control form-control-sm"
                    v-model="modalCreateProfit.type"
                  >
                    <option
                      v-for="(v, k) in modalCreateProfit.typeArr"
                      :key="v"
                      :value="k"
                    >
                      {{ v }}
                    </option>
                  </select>
                </div>
                <div class="col-1">
                  <i
                    class="ion-ios-help-outline tx-20 tx-info"
                    data-toggle="tooltip-primary"
                    data-placement="top"
                    data-html="true"
                    :data-original-title="
                      modalCreateProfit.type == 1
                        ? $t('financial.以库存SKU成本统计：') +
                          `<br> 
                      ` +
                          $t('financial.订单毛利 = 订单商品总额 - 库存SKU成本')
                        : $t('financial.以原料成本统计：') +
                          `<br>
                      ` +
                          $t('financial.订单毛利 = 订单商品总额 - 原来成本')
                    "
                  ></i>
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.生产成本：") }}</label
                >
                <div class="col-3 d-flex align-items-center">
                  <span>{{ modalCreateProfit.productCost }}</span>
                  <span class="mg-l-5">{{ $t("financial.元") }}</span>
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.采料成本：") }}</label
                >
                <div class="col-3 d-flex align-items-center">
                  <span>{{ modalCreateProfit.purchaseCost }}</span>
                  <span class="mg-l-5">{{ $t("financial.元") }}</span>
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.场地成本：") }}</label
                >
                <div class="col-3 d-flex align-items-center">
                  <input
                    class="mg-r-5 form-control form-control-sm"
                    type="text"
                    v-PRICE
                    v-model="modalCreateProfit.siteCost"
                  />
                  <span>{{ $t("financial.元") }}</span>
                </div>
                <div class="col-5 d-flex align-items-center">
                  {{ $t("financial.(如不统计该项可留空)") }}
                </div>
              </div>
              <div class="form-group row d-flex align-items-center">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.其他支出成本：") }}</label
                >
                <div class="col-7 d-flex align-items-center">
                  <span class="mg-r-15"
                    >{{ Number(modalCreateProfit.orderCost).toFixed(2) }}
                    {{ $t("financial.元") }}</span
                  >
                  <span class="mg-r-15"
                    >({{ $t("financial.共") }}
                    {{ modalCreateProfit.otherCostCnt }}
                    {{ $t("financial.条") }})</span
                  >
                  <i
                    class="ion-ios-help-outline tx-20 tx-info"
                    data-toggle="tooltip-primary"
                    data-placement="top"
                    data-html="true"
                    :data-original-title="
                      $t(
                        'financial.其他成本支出流水可在【其他支出流水管理】页面根据实际情况进行添加和管理。'
                      )
                    "
                  ></i>
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-3 col-form-label form-control-sm text-right"
                  >{{ $t("financial.备注：") }}</label
                >
                <div class="col-9">
                  <textarea
                    rows="2"
                    class="form-control form-control-sm"
                    v-model="modalCreateProfit.remark"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                :disabled="
                  modalCreateProfit.mode != 2 ||
                  !Number(modalCreateProfit.orderCnt)
                "
                @click="saveCreateProfit"
              >
                {{ $t("financial.生成利润报表") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("financial.关闭") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalProfitLog'"
        :home="false"
        :loading="false"
        :size="'md'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("financial.操作日志") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <ul class="row">
              <li
                v-for="item in modalProfitLog.items"
                :key="item"
                class="mg-b-10 col-12"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("financial.关闭") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalModiName'"
        :home="false"
        :loading="modalModiName.loading"
        :size="'md'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("financial.修改报表名称：") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="form-group row align-items-center">
              <label class="col-3 col-form-label form-control-sm text-right"
                >{{ $t("financial.报表名称：")
                }}<span class="tx-danger">*</span></label
              >
              <div class="col-6">
                <input
                  class="mg-r-5 form-control form-control-sm"
                  type="text"
                  v-model="modalModiName.name"
                />
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveModiName"
              >
                {{ $t("financial.保存") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("financial.关闭") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalCancelProfit'"
        :home="false"
        :loading="modalCancelProfit.loading"
        :size="'sm'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("financial.作废报表：") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="row">
              <div class="col-12">
                {{ $t("financial.确定要作废报表") }} "<span class="tx-danger">{{
                  modalCancelProfit.name
                }}</span
                >" {{ $t("financial.吗？") }}
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-danger
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveCancelProfit"
              >
                {{ $t("financial.作废") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("financial.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalReCalculate'"
        :home="false"
        :loading="modalReCalculate.loading"
        :size="'sm'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("financial.重新统计报表：") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="row">
              <div class="col-12">
                {{ $t("financial.确定要重新统计报表") }} "<span
                  class="tx-primary"
                  >{{ modalReCalculate.name }}</span
                >" {{ $t("financial.吗？") }}
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveReCalculate"
              >
                {{ $t("financial.重新统计") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("financial.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
    </div>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components/Modal";
import { pagination } from "@components/pagination.js"; //分页

export default {
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      firstLoading: true,
      loading: false,
      page: this.$route.params.page ? this.$route.params.page : 1,
      totalPage: 1,
      rowsPerPage: parseInt(store.get("profit-rowsPerPage"))
        ? parseInt(store.get("profit-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50, 100, 200, 500],
      totalCount: 0,
      items: [],
      filterProps: {
        name: "",
        code: "",
        dateFrom: "",
        dateTo: "",
        status: "",
      },
      modalCreateProfit: {
        max: false,
        loading: false,
        mode: 1,
        dateFrom: "",
        dateTo: "",
        orderCnt: 0,
        productCnt: 0,
        purchaseCnt: 0,
        orderCost: 0,
        productCost: 0, // 生产成本
        purchaseCost: 0, // 采料成本
        siteCost: "", //场地成本
        otherCost: "", //其他成本
        otherCostCnt: "", //其他条数
        remark: "",
        type: 1,
        typeArr: {
          1: this.$t("financial.以库存商品成本统计"),
          2: this.$t("financial.以原材料成本统计"),
        },
      },
      modalCreateProfitDefault: "",
      modalProfitLog: {
        items: [],
      },
      modalModiName: {
        loading: false,
        id: "",
        name: "",
      },
      modalCancelProfit: {
        loading: false,
        id: "",
        name: "",
      },
      modalReCalculate: {
        loading: false,
        id: "",
        name: "",
      },
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("profit-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    changeSize() {
      this.modalCreateProfit.max = !this.modalCreateProfit.max;
      $("#modalAgree .modal-dialog").removeAttr("style");
    },
    getOrder(id) {
      // 跳转到订单
      this.loading = true;
      let newW = window.open("//5yoho.cn/blank.html");
      $.api_call("api.Profit.getOrders", { id }, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          if (r.Data.Results.length) {
            newW.location.href = `/supplier/#/order-manager?from=profit&codes=${encodeURIComponent(
              r.Data.Results.join(",")
            )}`;
          } else {
            // 没有数据
            newW.close();
            ShowTip(this.$t("financial.没有查询到订单号"), "danger");
          }
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    setSkus(item, type) {
      this.loading = true;
      let newW = window.open("//5yoho.cn/blank.html");
      $.api_call("api.Profit.getSkus", { id: item.id, getType: type }, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          if (r.Data.Results.length) {
            if (type == 1) {
              newW.location.href = `/supplier/#/s-product?from=profit&sku=${encodeURIComponent(
                r.Data.Results.join(",")
              )}`;
            } else if (type == 2) {
              newW.location.href = `/supplier/#/storage-pro?from=profit&sku=${encodeURIComponent(
                r.Data.Results.join(",")
              )}`;
            }
          } else {
            // 没有数据
            newW.close();
            ShowTip(this.$t("financial.没有需要操作的SKU"), "danger");
          }
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    saveReCalculate() {
      // 保存重新统计
      this.modalReCalculate.loading = true;
      $.api_call(
        "api.Profit.reCalculate",
        { id: this.modalReCalculate.id },
        (r) => {
          this.modalReCalculate.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems(true);
            ShowTip(this.$t("financial.重新统计提交成功"), "success");
            $("#modalReCalculate").modal("hide");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    reCalculate(item) {
      // 打开重新统计
      this.modalReCalculate.loading = false;
      this.modalReCalculate.id = item.id;
      this.modalReCalculate.name = item.name;
      $("#modalReCalculate").modal("show");
    },
    saveCancelProfit() {
      //保存作废
      this.modalCancelProfit.loading = true;
      $.api_call(
        "api.Profit.cancelBySupplier",
        { id: this.modalCancelProfit.id },
        (r) => {
          this.modalCancelProfit.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems(true);
            ShowTip(this.$t("financial.作废报表成功"), "success");
            $("#modalCancelProfit").modal("hide");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    cancelProfit(item) {
      // 打开作废
      this.modalCancelProfit.loading = false;
      this.modalCancelProfit.id = item.id;
      this.modalCancelProfit.name = item.name;
      $("#modalCancelProfit").modal("show");
    },
    saveModiName() {
      //保存改名
      if (!this.modalModiName.name) {
        ShowTip(this.$t("financial.报表名称不得为空"), "danger");
        return false;
      }
      this.modalModiName.loading = true;
      $.api_call(
        "api.Profit.changeBySupplier",
        {
          name: this.modalModiName.name,
          id: this.modalModiName.id,
        },
        (r) => {
          this.modalModiName.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems(true);
            ShowTip(this.$t("financial.报表名称修改成功"), "success");
            $("#modalModiName").modal("hide");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    modiName(item) {
      //打开改名
      this.modalModiName.loading = false;
      this.modalModiName.id = item.id;
      this.modalModiName.name = item.name;
      $("#modalModiName").modal("show");
    },
    showOperateLog(item) {
      // 显示日志
      if (item.length) {
        this.modalProfitLog.items = item;
        $("#modalProfitLog").modal("show");
      }
    },
    saveCreateProfit() {
      //保存生成利润报表
      this.modalCreateProfit.loading = true;
      let params = {
        type: this.modalCreateProfit.type,
        dateFrom: this.modalCreateProfit.dateFrom,
        dateTo: this.modalCreateProfit.dateTo,
        orderCnt: this.modalCreateProfit.orderCnt,
        productCnt: this.modalCreateProfit.productCnt,
        purchaseCnt: this.modalCreateProfit.purchaseCnt,
        productCost: this.modalCreateProfit.productCost,
        purchaseCost: this.modalCreateProfit.purchaseCost,
        siteCost: this.modalCreateProfit.siteCost,
        otherCost: this.modalCreateProfit.otherCost,
      };
      $.api_call("api.Profit.create", params, (r) => {
        this.modalCreateProfit.loading = false;
        if (r.ErrorCode == "9999") {
          //本次选择存本地
          localStorage.setItem("createProfitType", this.modalCreateProfit.type);
          this.getItems(true);
          ShowTip(this.$t("financial.生成利润报表成功"), "success");
          $("#modalCreateProfit").modal("hide");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getOrdersNum() {
      //获取时间段订单数据
      this.modalCreateProfit.loading = true;
      $.api_call(
        "api.Profit.findsOrders",
        {
          dateFrom: this.modalCreateProfit.dateFrom,
          dateTo: this.modalCreateProfit.dateTo,
        },
        (r) => {
          this.modalCreateProfit.loading = false;
          if (r.ErrorCode == "9999") {
            const res = r.Data.Results || {};
            this.modalCreateProfit.mode = 2;
            this.modalCreateProfit.orderCnt = res.orderCnt;
            this.modalCreateProfit.productCnt = Number(res.productCnt);
            this.modalCreateProfit.purchaseCnt = Number(res.purchaseCnt);
            this.modalCreateProfit.productCost = Number(
              res.productCost
            ).toFixed(4);
            this.modalCreateProfit.purchaseCost = Number(
              res.purchaseCost
            ).toFixed(4);
            this.modalCreateProfit.orderCost =
              this.modalCreateProfit.otherCost = res.otherCost;
            this.modalCreateProfit.otherCostCnt = res.otherCostCnt;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    createProfit() {
      this.modalCreateProfit = JSON.parse(this.modalCreateProfitDefault);
      //获取本地上次的选择
      this.modalCreateProfit.type = localStorage.getItem("createProfitType")
        ? localStorage.getItem("createProfitType")
        : 1;
      this.datepickerSelect();
      $("#modalCreateProfit").modal("show");
    },
    getItems(s) {
      if (!this.isSysRights("Profit.findBySupplier")) return;
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        name: this.filterProps.name,
        code: this.filterProps.code,
        dateFrom: this.filterProps.dateFrom,
        dateTo: this.filterProps.dateTo,
        status: this.filterProps.status,
      };
      $.api_call("api.Profit.findBySupplier", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.firstLoading = false;
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          if (!s) $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    clearKey(type) {
      this.filterProps[type] = "";
      this.toPage(1);
    },
    filtrate(name, code, dateFrom, dateTo, status) {
      (this.filterProps = {
        name,
        code,
        dateFrom,
        dateTo,
        status,
      }),
        this.toPage(1);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/profit/" + 1 });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/profit/" + num });
      if (page == num) {
        this.getItems();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
    datepickerSelect() {
      let vm = this;
      //日期控件初始化
      $("#modalCreateProfit [data-id]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            if ($(this).data("id") == "datepicker-from") {
              $(this)
                .parents(".datepicker-group")
                .find($("[data-id=datepicker-to]"))
                .datepicker("option", "minDate", selectedDate);
            } else if ($(this).data("id") == "datepicker-to") {
              $(this)
                .parents(".datepicker-group")
                .find($("[data-id=datepicker-from]"))
                .datepicker("option", "maxDate", selectedDate);
            }
          },
          onSelect: function (selectedDate) {
            if ($(this).data("id") == "datepicker-from") {
              vm.modalCreateProfit.dateFrom = selectedDate;
            } else if ($(this).data("id") == "datepicker-to") {
              vm.modalCreateProfit.dateTo = selectedDate;
            }
            if (vm.modalCreateProfit.dateFrom && vm.modalCreateProfit.dateTo) {
              //全选后刷新订单数
              vm.getOrdersNum();
            }
          },
        });
      });
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.modalCreateProfitDefault = JSON.stringify(this.modalCreateProfit);
    this.getItems();
    $("#modalProfitLog").on("shown.bs.modal", function (e) {
      //备注打开后滚到顶
      $("#modalProfitLog .modal-body").scrollTop(0);
    });
  },
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
};
</script>

<style lang="less" scoped>
.body-inner {
  [data-id="datepicker-from"],
  [data-id="datepicker-to"] {
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    color: #495057;
  }
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }
}
.nav.nav-outline {
  padding: 0 15px;
}
</style>